module.exports = __webpack_public_path__ + "150200f3ae96d6f581dac67ee877c746.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/line-topup.png
// module id = 568
// module chunks = 30